module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"es":{"uso":"Uso","tipo_soporte":"Tipo de soporte","intensidad_transito":"Intensidad de tránsito","riesgo_helada":"Riesgo de helada"}}')
  delete Component.options._Ctor
}
